/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { GetPartQueryResponse, GetPartPathParams, GetPart400, GetPart401, GetPart403, GetPart404, GetPart409, GetPart500 } from "../../types/equipmentController/GetPart.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getPart } from "../../client/equipmentController/getPart.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getPartQueryKey = (organizationId: GetPartPathParams["organizationId"] | undefined, partId: GetPartPathParams["partId"] | undefined) => [{ url: '/api/organizations/:organizationId/equipment/parts/:partId', params: {organizationId:organizationId,partId:partId} }] as const

export type GetPartQueryKey = ReturnType<typeof getPartQueryKey>

export function getPartQueryOptions(organizationId: GetPartPathParams["organizationId"] | undefined, partId: GetPartPathParams["partId"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getPartQueryKey(organizationId, partId)
        return queryOptions<GetPartQueryResponse, ResponseErrorConfig<GetPart400 | GetPart401 | GetPart403 | GetPart404 | GetPart409 | GetPart500>, GetPartQueryResponse, typeof queryKey>({
         enabled: !!(organizationId && partId),
         queryKey,
         queryFn: async ({ signal }) => {
            return getPart(organizationId!, partId!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get part detail
 * {@link /api/organizations/:organizationId/equipment/parts/:partId}
 */
export function useGetPart<TData = GetPartQueryResponse, TQueryData = GetPartQueryResponse, TQueryKey extends QueryKey = GetPartQueryKey>(organizationId: GetPartPathParams["organizationId"] | undefined, partId: GetPartPathParams["partId"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetPartQueryResponse, ResponseErrorConfig<GetPart400 | GetPart401 | GetPart403 | GetPart404 | GetPart409 | GetPart500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getPartQueryKey(organizationId, partId)
         

         const query = useQuery({
          ...getPartQueryOptions(organizationId, partId, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetPart400 | GetPart401 | GetPart403 | GetPart404 | GetPart409 | GetPart500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}